<article id="{{slug}}Home" class="w-full overflow-hidden" style="height: 100dvh;">
  <section
    class="w-full h-full p-3 md:px-6 relative flex flex-column align-items-center justify-content-end bg-cover bg-center"
    style="background: url({{data?.assets?.backgroundUrl}});">
    <section class="w-fit h-auto p-3 flex flex-column gap-3 align-items-center z-3 border-round-xl container shadow-3">
      <p *ngIf="data.description"
         class="md:max-w-27rem text-center text-3xl md:text-4xl font-normal ci-txt--white">
        {{data.description}}
      </p>

      <a *ngIf="!data.redirect && !data.hasFunction" [routerLink]="[data.slug]" >
        <button class="w-fit ci-btn ci-btn--medium ci-btn__{{color}}">
          {{data.buttonLabel}}
        </button>
      </a>

      <button *ngIf="data.redirect && !data.hasFunction" class="w-fit ci-btn ci-btn__{{color}}" (click)="openLink()">
        {{data.buttonLabel}}
      </button>

      <button *ngIf="data.hasFunction && !data?.modalService" class="w-fit ci-btn ci-btn__{{color}}"
        (click)="data.action()">
        {{data.buttonLabel}}
      </button>

      <button *ngIf="data.hasFunction && data?.modalService" class="w-fit ci-btn ci-btn__{{color}}"
        (click)="data.action(dialogService)">
        {{data.buttonLabel}}
      </button>
    </section>

    <section *ngIf="scrollSectionId"
      class="w-full flex justify-content-center mt-3 fadeindown animation-duration-500 z-3"
      (click)="scrollToFeatureSection()">
      <i
        class="bi bi-chevron-double-down ci-txt--white text-3xl md:text-4xl ci-project-banner__arrow-down cursor-pointer">
      </i>
    </section>

    <section class="w-full h-full bg-black-alpha-40 absolute top-0 right-0 left-0 bottom-0 z-2"></section>

    <article *ngIf="data?.assets?.videoUrl"
      class="fadein animation-duration-500 video-container absolute top-0 right-0 left-0 bottom-0 z-1">
      <video autoplay muted loop playsinline id="background-video" class="background-video">
        <source src="{{data?.assets?.videoUrl}}" type="video/mp4">
      </video>
    </article>
  </section>
</article>

<style>
  .container {
    width: 300px;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
  }

  .video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .background-video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
</style>